import styled from 'styled-components';

export const LoadingPageWrap = styled.div`
  position: fixed;
  top: 0;
  left: calc(50% + 12px);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 486px;
  height: 100dvh;
  background-color: #fff;
  z-index: 40;

  @media only screen and (max-width: 1200px) {
    left: 50%;
    transform: translate(-50%, 0);
  }
`;
